import { matchingEngineApi } from '../matching-engine.utils';
import { UseMutationOptions } from 'react-query';
import { useMutation } from 'common/hooks';
export const useDeleteSkillFeedback = (options: UseMutationOptions = {}) => {
  const deleteFeedbacks = (feedbackId: string) => {
    return matchingEngineApi.delete(`delete-skill-feedback/${feedbackId}`);
  };

  return useMutation(deleteFeedbacks, {
    showSuccessSnackbar: true,
    ...options,
  });
};
